<template>
  <ExpiringImage
    v-if="model"
    :src="src"
    :record-id="model.id"
    :url-key="urlKey"
    :fallback="defaultImageSrc"
  />
  <img v-else :src="defaultImageSrc" />
</template>

<script>
import ExpiringImage from "@/components/common/ExpiringImage";

export default {
  name: "vehicle-image",
  components: { ExpiringImage },
  props: ["thumb", "model"],
  data() {
    return {
      defaultImageSrc: "/frontend/img/sample-car.png"
    };
  },
  computed: {
    /**
     * Which key of the image the caller asked for: the full size when thumb is
     * explicitly false, a named one when it is a key this model carries, the
     * thumbnail otherwise. ExpiringImage needs the key rather than only the value,
     * so it can ask for the same one again once the URL has expired.
     */
    urlKey() {
      if (this.thumb === false) return "url";
      if (this.thumb && this.model[this.thumb]) return this.thumb;

      return this.model.thumb_url ? "thumb_url" : "url";
    },
    src() {
      return this.model[this.urlKey];
    }
  },
  methods: {
    onBookClick() {
      this.$emit("book", this.model);
    }
  }
};
</script>
